const map = {
	"./banner1.png": 46767,
	"./banner1E.png": 40066,
	"./banner2.png": 72276,
	"./banner2E.png": 82979,
	"./banner3.png": 88957,
	"./banner3E.png": 69780,
	"./banner4.png": 1058,
	"./banner4E.png": 60245,
	"./banner5.png": 22187,
	"./banner5E.png": 84750,
	"./banner6.png": 50896,
	"./banner6E.png": 76111,
	"./banner_chinese_1.png": 60848,
	"./banner_english_1 .png": 80357,
	"./banner_first.jpg": 68687,
	"./banner_firstE.jpg": 73622,
	"./bannernew_chinese_1.png": 53396,
	"./bannernew_chinese_2.png": 74863,
	"./img_chinese_1.png": 42133,
	"./img_english_1.png": 97188
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25144;